import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  LoadingController,
} from "ionic-angular";
import { Clipboard } from "@ionic-native/clipboard";

import { ReciclagemProvider } from "../../../providers/reciclagem/reciclagem.provider";
import { ReciboProvider } from "../../../providers/reciclagem/recibo.provider";
import { ParticipacaoProvider } from "../../../providers/participacao/partipacao.provider";

import { ParticipacaoPage } from "../../participacao/participacao";

@IonicPage({
  name: "page-reciclagem-historico",
  segment: "page-reciclagem-historico/:id",
})
@Component({
  selector: "page-reciclagem-historico",
  templateUrl: "reciclagem-historico.html",
})
export class ReciclagemHistoricoPage {
  evento_aberto: any;
  participante: any | false = false;
  _reciclagens: any | false = false;
  reciclagens: any | false = false;
  searchTerm: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public reciclagemProvider: ReciclagemProvider,
    public participacaoProvider: ParticipacaoProvider,
    public reciboProvider: ReciboProvider,
    public alertCtrl: AlertController,
    public loadCtrl: LoadingController,
    public toastCtrl: ToastController,
    private clipboard: Clipboard
  ) {
    this.getParticipante(this.navParams.get("id"));
    this.getReciclagems(this.navParams.get("id"));
  }

  copiarCodigo(codigo: string) {
    const onSuccess = () => {
      const toast = this.toastCtrl.create({ message: 'Código copiado!', duration: 1500 });
      toast.present();
    };

    // Cordova plugin (device nativo)
    this.clipboard.copy(codigo).then(onSuccess).catch(() => {
      // Fallback: Web Clipboard API (browser/PWA)
      if (navigator['clipboard']) {
        navigator['clipboard'].writeText(codigo).then(onSuccess);
      }
    });
  }

  enviarRecibo(tipo: string, reciclagem_id) {
    if (tipo === "EMAIL") this.prompt(reciclagem_id, "email");
    if (tipo === "SMS") this.prompt(reciclagem_id, "sms");
  }

  goToParticipacao() {
    this.navCtrl.popTo(ParticipacaoPage);
  }

  onSearchInput() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      this.reciclagens = [...this._reciclagens];
      return;
    }

    const term = this.searchTerm.toLowerCase();
    this.reciclagens = this._reciclagens.filter(item => {
      for (let key in item) {
        if (
          item[key] &&
          item[key].toString().toLowerCase().indexOf(term) !== -1
        ) {
          return true;
        }
      }
      return false;
    });
  }

  /* Privates */
  private getParticipante(participacao_id) {
    let load = this.loadCtrl.create({
      content: "Buscando dados do Cliente...",
    });
    load.present();

    this.participacaoProvider
      .getById(participacao_id)
      .subscribe((participante) => {
        this.participante = participante;
        load.dismiss();
      });
  }

  private getReciclagems(participacao_id) {
    let load = this.loadCtrl.create({ content: "Buscando reciclagems..." });
    load.present();

    this.reciclagemProvider
      .getByParticipacao(participacao_id)
      .subscribe((reciclagens) => {
        reciclagens.forEach(r => {
          let peso = 0;
          if (r.residuos) {
            r.residuos.forEach(res => peso += parseFloat(res.quantidade) || 0);
          }
          r.peso_total = peso.toFixed(2);
        });
        this._reciclagens = reciclagens;
        this.reciclagens = reciclagens;
        load.dismiss();
      });
  }

  private prompt(reciclagem_id, forma: string) {
    this.reciclagemProvider.getById(reciclagem_id).subscribe((reciclagem) => {
      this.showPrompt(reciclagem, forma);
    });
  }

  private showPrompt(reciclagem, forma: string) {
    let title, input, placeholder, inputvalue;
    if (forma === "email") {
      title = "E-mail";
      input = "email";
      placeholder = "email@provedor.com";
      inputvalue = reciclagem.participacao.cliente.email;
    } else if (forma === "sms") {
      title = "SMS";
      input = "celular";
      placeholder = "99 9 9999 9999";
      inputvalue = reciclagem.participacao.cliente.celular;
    }

    let alert = this.alertCtrl.create({
      title: "Recibo via " + title,
      inputs: [
        {
          name: input,
          placeholder: placeholder,
          value: inputvalue,
        },
      ],
      buttons: [
        {
          text: "Desistir",
          role: "cancel",
        },
        {
          text: "ENVIAR",
          handler: (data) => {
            if (forma === "email") {
              if (data.email !== "") {
                let load = this.loadCtrl.create({
                  content: "Enviando E-mail...",
                });
                load.present();
                this.reciboProvider
                  .enviarEmail(reciclagem, data.email)
                  .then((success) => {
                    load.dismiss();
                    console.log("sucesso:", success);
                  })
                  .catch((reject) => {
                    load.dismiss();
                    console.log("error:", reject);
                  });
              } else {
                return false;
              }
            } else if (forma === "sms") {
              if (data.celular !== "") {
                let load = this.loadCtrl.create({ content: "Enviando SMS..." });
                let mobile = data.celular;
                load.present();
                reciclagem.data = new Date();

                let send = this.reciboProvider.enviarSMS(reciclagem, mobile);
                if (send) {
                  load.dismiss();
                  let toast = this.toastCtrl.create({ duration: 1500 });

                  toast.setMessage("SMS Enviado com Sucesso!");
                  toast.present();
                } else {
                  load.dismiss();

                  let toast = this.toastCtrl.create({ duration: 1500 });
                  toast.setMessage("Houve um erro ao enviar o SMS :(");
                  toast.present();
                }
              } else {
                return false;
              }
            }
          },
        },
      ],
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem-historico/reciclagem-historico.ts